import api from "./api";

// Devil's Quadrangle performance layer (FBPM Ch.2 / Ch.8).

/** First-cut AS-IS performance snapshot (time + cost) for a process. */
export async function getPerformanceSnapshot(processId) {
  return api.get(`/process/${processId}/performance`);
}

/** Performance targets set for a process (one per dimension). */
export async function getPerformanceTargets(processId) {
  return api.get(`/process/${processId}/performance/targets`);
}

/** Create/update performance targets. `targets` is an array of
 *  { id?, dimension, aggregation?, measure_name?, baseline_value?, target_value?,
 *    threshold_value?, timeframe_date?, custom_uom? }. */
export async function savePerformanceTargets(processId, targets) {
  return api.patch(`/process/${processId}/performance/targets`, { targets });
}

export async function deletePerformanceTarget(processId, targetId) {
  return api.delete(`/process/${processId}/performance/targets/${targetId}`);
}
